/* global app */
/* global event */
/* global calendar, groups, notAttendetReasons, gui, foods */
app.controller('AdministerCtrl', ['$rootScope', '$scope', '$http','$compile', 'NetworkService','AtlasDialog','AtlasNotification','$timeout', function($rootScope, $scope, $http,$compile, NetworkService, AtlasDialog, AtlasNotification, $timeout) {

    $scope.fields = {};
    $scope.columnsPerView = 3;
    $scope.actualPage = 1; // Page Id starts with 1
    $scope.htmlClasses = {};
    $scope.calendar = calendar;
    $scope.event = event;
    $scope.gui = {editMode: false}
    $scope.groups = groups;
    $scope.foods = foods;
    $scope.showPhantomFood = false;
    $scope.phantomFoodName = "";
    
    
   

    $scope.htmlClasses.prevArrow = {
        "ac-icon-button--disabled": true
    }
    
    $scope.deleteSelectedFood = function(){
        var data = {
            foodArray: $scope.dataTables.foodTable.selected,
            eventId: $scope.event.Veranstaltungsnummer
        };
        NetworkService.callOperation("removeFoodFromEvent", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("Verpflegung wurde erfolgreich gelöscht.");
                    NetworkService.callOperation("reload/administer/"+$scope.event.Veranstaltungsnummer, data, function(response) {
                        if(response.isSuccessfull()){
                            $scope.foods = response.get("foods")
                        }
                    })
                }
            })
    }
    
    $scope.openDelteShiftYesNo = function(job){
        console.log(job)
        var shiftId = job["alle_schichten_id"];
        AtlasDialog.yesNo("Schicht sicher löschen?", function(){
            NetworkService.callOperation("deleteShift", {shiftId: shiftId}, function(data, meta){
                AtlasNotification.info("Schicht erfolgreich gelöscht.");
                $scope.updateCalendar();
            })
        }, function(){
            console.log("nein")
        })
    }
    
    $scope.addEventFood = function(food){
        var data = {
            foodName: $scope.phantomFoodName,
            eventId: $scope.event.Veranstaltungsnummer
        };
        NetworkService.callOperation("addFoodToEvent", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("Verpflegung wurde erfolgreich hinzugefügt.");
                    NetworkService.callOperation("reload/administer/"+$scope.event.Veranstaltungsnummer, data, function(response) {
                        if(response.isSuccessfull()){
                            $scope.foods = response.get("foods")
                        }
                    })
                }
            })
    }

    $scope.htmlClasses.nextArrow = {
        "ac-icon-button--disabled": false
    }

    $scope.requiredFieldsChecked = function(allFieldsPresent) {
        $scope.gui.okButtonDisabled = !allFieldsPresent
    }

    $scope.openEditPositionDialog = function(position){
        gui.openDialog("editPositionDialog");
        $rootScope.$emit("editPositionDialog", position.position)
    }
    $scope.nextPage = function() {
        var pages = $(".ac-job--col").length / $scope.columnsPerView;
        if ($scope.actualPage < pages) {
            $scope.actualPage++;
            $scope.changePage($scope.actualPage);
            $scope.htmlClasses.prevArrow["ac-icon-button--disabled"] = false;
            if ($scope.actualPage == pages) {
                $scope.htmlClasses.nextArrow["ac-icon-button--disabled"] = true;
            }
        }
    }
    
    
    $scope.eventHasFoodChanged = function(){
        var eventState = {
            eventId: $scope.event.Veranstaltungsnummer,
            hasfood: $scope.event.hasfood
        }
        NetworkService.callOperation("updateevent", eventState, function(response){
            AtlasNotification.info("Die Verpflegung wurde erfolgreich geändert.");
        })
    }
    
    $scope.eventStateChanged = function(){
        var eventState = {
            eventId: $scope.event.Veranstaltungsnummer,
            eventState: $scope.event.Freigegeben
        }
        NetworkService.callOperation("updateevent", eventState, function(response){
            AtlasNotification.info("Event-Status wurde erfolgreich geändert.");
        })
    }
    
    $scope.safeEventName = function(){
        var eventName = {
            eventId: $scope.event.Veranstaltungsnummer,
            eventName: $scope.event.Veranstaltungsname
        }
        NetworkService.callOperation("updateevent", eventName, function(response){
            AtlasNotification.info("Name der Veranstaltung wurde erfolgreich geändert.");
        })    
    }
    
    $scope.setEditMode = function(){
        $scope.gui.editMode = true;
    }
    
    $scope.openUser = function(userId){
        var win = window.open("/user/"+userId, '_blank');
        win.focus();
    }
    
    $scope.openChangeUserStateDialog = function(work, job){
        var dialogDef = {
            header: "Wähle einen Status",
            notice: "Der User wird über diese Änderung nicht informiert!",
            selected: work.approved,
            choices: [
                {name: "Angemeldet", value: 0},
                {name: "Akzeptiert", value: 1},
                {name: "Wartend auf User", value: 2}
                ]
        }
        AtlasDialog.simpleChoiceDialog(dialogDef, function(){
            var newState = dialogDef.selected;
            var data = {
                newState: newState,
                positionId: job.job.alle_positionen_id,
                shiftId: job.job.alle_schichten_id,
                userId: work.userId
            };
            NetworkService.callOperation("updateWorkState", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("Status wurde erfolgreich geändert.");
                    $scope.updateCalendar()
                }
            })
        }, function(){

        })
    }
    
    $rootScope.$on("updateCalendar", function(){
         $scope.updateCalendar();
    })
    
    $scope.updateCalendar = function(){
        NetworkService.callOperation("getAdministerData/"+event.Veranstaltungsnummer, {}, function(response){
            var data = response.getData();
            $scope.calendar = data.calendar;
            $scope.init();
            setTimeout(function(){
                gui.initMenus()
            },300)
        }) 
    }
    
    $scope.openRemoveUserNotAttendingdialog = function(work){
        var data = {
                workId: work.workId
            };
        NetworkService.callOperation("removeWorkNotAttended", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("Teilnahme-Status wurde erfolgreich geändert.");
                    $scope.updateCalendar();
                }
            })
    }
    
    $scope.openEditFoodDialog = function(work, job){
        var choices = [];
        $scope.foods.forEach(function(food){choices.push({name:food["Essen"], value:food["Essen"]})});
        var dialogDef = {
            header: "Wähle einen Status",
            notice: "Der User wird über diese Änderung nicht informiert!",
            selected: work.food,
            "choices": choices
        }

        AtlasDialog.simpleChoiceDialog(dialogDef, function(){
            var newState = dialogDef.selected;

            var data = {
                newFood: newState,
                workId: work.workId,
                userId: work.userId
            };
            
            NetworkService.callOperation("updateFoodForJob", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("Verpflegung wurde erfolgreich geändert.");
                    $scope.updateCalendar()
                }
            })
        }, function(){

        })
    }
    
    $scope.openSetUserNotAttendingdialog = function(work, job){
        var dialogDef = {
            header: "Wähle einen Grund",
            notice: "Der User wird über diese Änderung nicht informiert!",
            selected: work.approved,
            onePerLine: true,
            choices: notAttendetReasons
        }
        AtlasDialog.simpleChoiceDialog(dialogDef, function(){
            var reasonId = dialogDef.selected;
            var data = {
                reason: reasonId,
                workId: work.workId
            };
            NetworkService.callOperation("setWorkNotAttended", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("Teilnahme-Status wurde erfolgreich geändert.");
                    $scope.updateCalendar();
                }
            })
        }, function(){

        })
    }
    
    $scope.searchForUser = function(){
        //console.log(window.searches.userSearch.searchField)
        console.log($scope.searches)
        var spl = window.searches.userSearchAddUser.searchField.split(" ");
        if(spl.length == 1){
            var user = {
            email: window.searches.userSearchAddUser.searchField,
            firstName: window.searches.userSearchAddUser.searchField,
            secondName: window.searches.userSearchAddUser.searchField
            };
        }else if(spl.length == 2){
            var user = {
            email: window.searches.userSearchAddUser.searchField,
            firstName: spl[0],
            secondName: spl[1]
            };
        }

    }
    
    if(window.searches == undefined){
        window.searches = {};
    }
    if(window.searches.userSearchAddUser == undefined){
        window.searches.userSearchAddUser = {};
    }
    
    $scope.openAddUserDialog = function(work){
        AtlasDialog.searchUserDialog(function(res){
            var data = {
                shiftId: work.alle_schichten_id,
                positionId: work.alle_positionen_id,
                userId: res.selectedUser.id
            };
            NetworkService.callOperation("addUserToJob", data, function(response) {
                if(response.isSuccessfull()){
                    AtlasNotification.info("User wurde erfolgreich hinzugefügt.");
                    $scope.updateCalendar();
                }
            })
        }, function(){
            
        })
    }
    $scope.openPrintMenue = function(){
        /*AtlasNotification.info("Download wird durchgeführt");
        var eventId = $scope.event.Veranstaltungsnummer;
        document.getElementById('download_iframe').src = "/excel/"+eventId;*/
        var formats = [
            {value: 1, name: "Teilnehmer-Liste", description: ""},
            {value: 3, name: "Teilnehmer-Liste vollständig", description: ""},
            {value: 2, name: "Schichtplan", description: ""}]
          var dialogDef = {
            header: "Wähle ein Format",
            notice: "",
            selected: 1,
            onePerLine: true,
            choices: formats
        }
        AtlasDialog.simpleChoiceDialog(dialogDef, function(){
            var formatId = dialogDef.selected;
            /*var data = {
                reason: reasonId,
                workId: work.workId
            };*/
            if(formatId == 2){
                AtlasNotification.info("Download wird durchgeführt");
                var eventId = $scope.event.Veranstaltungsnummer;
                document.getElementById('download_iframe').src = "/excel/"+eventId;
            }else if(formatId == 1){
                AtlasNotification.info("Download wird durchgeführt");
                var eventId = $scope.event.Veranstaltungsnummer;
                document.getElementById('download_iframe').src = "/csv/"+eventId;
            }else if(formatId == 3){
                AtlasNotification.info("Download wird durchgeführt");
                var eventId = $scope.event.Veranstaltungsnummer;
                document.getElementById('download_iframe').src = "/csvFull/"+eventId;
            }
        }, function(){

        })
    }
    
    $scope.acceptWaitingJob = function(shiftId, positionId, userId){
        AtlasDialog.yesNo("Es wird auf eine interaktion des Users gewartet. Trotzdem freischalten?", function(){
            NetworkService.callOperation("acceptJob", {shiftId: shiftId, positionId: positionId, userId: userId}, function(data, meta){
                AtlasNotification.info("Job erfolgreich akzeptiert");
                $scope.updateCalendar();
            })
        }, function(){
            console.log("nein")
        })
    }
    
    $scope.acceptJob = function(shiftId, positionId, userId){
        AtlasDialog.yesNo("Job akzeptieren?", function(){
            NetworkService.callOperation("acceptJob", {shiftId: shiftId, positionId: positionId, userId: userId}, function(data, meta){
                AtlasNotification.info("Job erfolgreich akzeptiert");
                 $scope.updateCalendar();
            })
        }, function(){
            console.log("nein")
        })
    }

    $scope.prevPage = function() {
        var pages = $(".ac-job--col").length / $scope.columnsPerView;
        if ($scope.actualPage > 1) {
            $scope.actualPage--;
            $scope.changePage($scope.actualPage);
            $scope.htmlClasses.nextArrow["ac-icon-button--disabled"] = false;
            if ($scope.actualPage == 1) {
                $scope.htmlClasses.prevArrow["ac-icon-button--disabled"] = true;
            }
        }
    }
    
    $scope.declineUser = function(worker, job){
        console.log(job)
        AtlasDialog.simpleTextDialog(function(res){
            var data = {
                userId: worker.userId,
                workId: worker.workId,
                reason: res.text, 
                shiftId: job.alle_schichten_id,
                positionId: job.alle_positionen_id
            }
            NetworkService.callOperation("declineJob", data, function(data, meta){
                AtlasNotification.info("Job erfolgreich abgelehnt.");
                $scope.updateCalendar();
            })
        }, function(){
            
        }, {header: "Grund:"})
    }

    $scope.changePage = function(pageId) {
        var to = (pageId * $scope.columnsPerView);
        var from = (to - $scope.columnsPerView);

        $(".ac-position-page-button").each(function(id, element) {
            if (id == pageId - 1) {
                $(element).addClass("ac-position-page-button--active")
            }
            else {
                $(element).removeClass("ac-position-page-button--active")
            }
        })

        var i = 0
        for (var positionId in $scope.calendar) {
            if ($scope.calendar[positionId]["gui"] == undefined) {
                $scope.calendar[positionId]["gui"] = {};
            }
            if (i < to && i >= from) {
                $scope.calendar[positionId]["gui"]["isVisible"] = true;
            }
            else {
                $scope.calendar[positionId]["gui"]["isVisible"] = false;
            }
            i++;
        }
        //$scope.$apply();

        $(".ac-position--header").each(function(id, element) {
            if (id < to && id >= from) {
                $(element).removeClass("ac-position--header--hidden")
            }
            else {
                $(element).addClass("ac-position--header--hidden")
            }
        })
    }


    $rootScope.$on("imageCropped", function(e,data){
        if(data.dataTarget == "AdministerCtrl"){
            NetworkService.callOperation("saveeventimage/"+event.Veranstaltungsnummer, data, function(){
                AtlasNotification.info("Bild wurde erfolgreich geändert.");
            })
        }
    })


    $scope.getAttendingWorkers = function(workersArray){
        var count = 0;
        for(var i = 0; i < workersArray.length; ++i){
            if(workersArray[i]["notAttendedReasonName"] == null)
                count++;
        }
        return count;
    }

    $scope.init = function() {
        if (window.mobilecheck()) {
            $scope.columnsPerView = 1;
        }
        $scope.changePage($scope.actualPage)
    }

    $scope.init()
}])
